import tools from '@/common/tools';
const mixin = {
    data(){
        return {
			extraForm: {},
            ExtraDataDefines: [],
            oldExtraForm: {}
        }
    },
    computed: {
        NonAthletes(){
            return this.isAthlete === false; //当前是非运动员
        },
        ExtraDataList(){
            let list = [];
            if(this.ExtraDataDefines && this.ExtraDataDefines.length > 0){
                let extraForm = this.extraForm;
				for(let i=0;i<this.ExtraDataDefines.length;i++){
					let item = this.ExtraDataDefines[i];
                    if(!item.ForNonAthletes && this.NonAthletes){
                        continue;
                    }
                    let isShow = this.getExtraEnable(item, extraForm);
                    if(isShow){
                        list.push(item);
                    }
				}
            }
            return list;
        }
    },
    methods: {
        //获取自定义 日期时间格式
        getDateFormat(DataType){
            let config = {};
            switch(DataType){
                case 'DateTime':
                    config.format = 'yyyy-MM-dd HH:mm';
                    config.datePickerType = 'datetime';
                    break;
                case 'Date':
                default:
                    config.format = 'yyyy-MM-dd';
                    config.datePickerType = 'date';
                    break;
            }
            return config;
        },
        //初始化自定义字段
		initExtraForm(ExtraDataDefines, Extras){
			if(ExtraDataDefines){
				this.ExtraDataDefines = ExtraDataDefines;
			}else{
				ExtraDataDefines = this.ExtraDataDefines;
			}
			if(Extras){
				this.oldExtraForm = Extras;
			}else{
				Extras = this.oldExtraForm;
			}
			if(ExtraDataDefines && ExtraDataDefines.length){
				let form = {};
				for(let i=0;i<ExtraDataDefines.length;i++){
					let item = ExtraDataDefines[i];
					if(['Date', 'DateTime'].includes(item.DataType) && Extras[item.Field]){
						let { format } = this.getDateFormat(item.DataType);
						form[item.Field] = tools.dateFormat(Extras[item.Field], format);
					}else{
						form[item.Field] = Extras[item.Field] || item.InputDefault || '';
					}
				}
				this.extraForm = form;
			}
		},
        //判断自定义字段的显示
        getExtraEnable(extra, extraForm){
            //默认隐藏
            if(extra.EnableWhen){
                let {
                    Field,
                    Operator,
                    Values
                } = extra.EnableWhen;
                let value = extraForm[Field];
                if(value){
                    if(Operator == 'IN'){//包含
                        return Values.includes(value);
                    }else if(Operator == 'NOT IN'){//不包含
                        return !Values.includes(value);
                    }
                } 
                return false;
            }
            //默认显示
            if(extra.DisableWhen){
                let {
                    Field,
                    Operator,
                    Values
                } = extra.DisableWhen;
                let value = extraForm[Field];
                if(value){
                    if(Operator == 'IN'){//包含
                        return !Values.includes(value);
                    }else if(Operator == 'NOT IN'){//不包含
                        return Values.includes(value);
                    }
                } 
                return true;
            }
            return true;
        },
        //自定义字段校验规则
        getExtraRule(item){
            return {
                validator:(value, callback)=>{
					let message;
					let isNull = [undefined, null, ''].includes(value);
					if(isNull){
						if(item.Mandatory){
                            if(item.DataType == 'Text'){
							    message = `请输入${item.Name}`;
                            }else if(['Number', 'Integer'].includes(item.DataType)){
                                message = `未输入${item.Name}或格式不正确`;
                            }else{
							    message = `请选择${item.Name}`;
                            }
						}
					}else{
						if(item.DataType == 'Text'){
							if(item.Min != null && value.length < +item.Min){
								message = `${item.Name}内容最小长度 ${item.Min}`;
							}else if(item.Max != null && value.length > +item.Max){
								message = `${item.Name}内容最大长度 ${item.Max}`;
							}
						}else if(['Number', 'Integer'].includes(item.DataType)){
							if(Number.isNaN(Number(value))){
								message = `${item.Name}不是数值`;
							}else if(item.DataType == 'Integer' && !Number.isInteger(value)){
								message = `${item.Name}不是整数`;
							}else if(item.Min != null && +value < +item.Min){
								message = `${item.Name}不能小于 ${item.Min}`;
							}else if(item.Max != null && +value > +item.Max){
								message = `${item.Name}不能大于 ${item.Max}`;
							}
						}
					}
					callback(message);
                }
            }
        },
        //检查自定义字段（提交时使用）
        verifyExtraForm(){
            let error;
            if(this.ExtraDataDefines && this.ExtraDataDefines.length > 0){
                let extraForm = this.extraForm;
				this.ExtraDataList.forEach(item=>{
					if(error) return true;
                    let value = extraForm[item.Field];
					
					let validator = this.getExtraRule(item).validator;
					let isValidator = false;
					validator(value, message=>{
						if(isValidator) return;
						isValidator = true;
						if(message){
							error = {
								id: item.Field,
								text: message
							}
						}
					})
				})
                return error;
            }
            return error;
        },
        //获取填写的自定义字段值（提交时使用）
        getExtraForm(){
            let extras = null;
            if(this.ExtraDataDefines && this.ExtraDataDefines.length > 0){
                let extraForm = this.extraForm;
                extras = {};
                for(let i=0;i<this.ExtraDataList.length;i++){
                    let item = this.ExtraDataList[i];
                    let value = extraForm[item.Field];
                    extras[item.Field] = value;
                }
                return extras;
            }
            return extras;
        }
    }
}

export default mixin;